import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const rejectPlannerByApprover = createApi(`RejectPlannerByApproverSlice`,"POST");

const RejectPlannerByApproverSlice = createSlice({
  name: 'RejectPlannerByApproverSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rejectPlannerByApprover.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rejectPlannerByApprover.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(rejectPlannerByApprover.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default RejectPlannerByApproverSlice.reducer;